module.exports = __webpack_public_path__ + "static/media/logo196.96d1c4f2.png";